const presential_en = require('./presential.json')
export default presential_en